const weekdays = {
  "en": () => {
    return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  },
  "fr": () => {
    return ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
  }
}

const weekdays_short = {
  "en": () => {
    return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  },
  "fr": () => {
    return ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
  }
}

const timeConvert = function (time) {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  if (time.length > 1) {
    time = time.slice(1);
    if (time.length === 4) {
      time.pop();
    }
    time[5] = +time[0] < 12 ? 'AM' : 'PM';
    time[0] = +time[0] % 12 || 12;
  }
  return time.join('');
}

const objectsAreEqual = function (a, b) {
  for (let k of Object.keys(a)) {
    if (!(k in b)) {
      return false
    }
  }
  for (let k of Object.keys(b)) {
    if (!(k in a)) {
      return false
    }
    if (b[k] !== a[k]) {
      return false
    }
  }
  return true
}

const handleize = function (str) {
  str = str.toLowerCase();
  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
  }

  str = str.replace(/[àáâãäå]/g, "a");
  str = str.replace(/æ/g, "ae");
  str = str.replace(/ç/g, "c");
  str = str.replace(/[èéêë]/g, "e");
  str = str.replace(/[ìíîï]/g, "i");
  str = str.replace(/ñ/g, "n");
  str = str.replace(/[òóôõö]/g, "o");
  str = str.replace(/œ/g, "oe");
  str = str.replace(/[ùúûü]/g, "u");
  str = str.replace(/[ýÿ]/g, "y");

  str = str.replace(/\W+/g, "-");
  if (str.charAt(str.length - 1) === "-") {
    str = str.substring(0, str.length - 1);
  }
  if (str.charAt(0) === "-") {
    str = str.substring(1, str.length)
  }
  return str
};

const _html_entities = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#39;',
}

const unescapeHTML = function (str) {
  if (str && typeof str === 'string') {
    for (let item of Object.entries(_html_entities)) {
      while (str.includes(item[1])) {
        str = str.replace(item[1], item[0])
      }
    }
  }
  return str
}

const merge_normal_and_special_hours = (normal_hours, special_hours) => {
  let current_date = new Date();
  let current_day = current_date.getDay();
  let dow_date
  if (normal_hours.length === 0) {
    return null
  }
  return (normal_hours || []).map((day, index) => {
    if (index === current_day) {
      dow_date = current_date
    } else {
      dow_date = new Date()
      dow_date.setDate(current_date.getDate() + (index > current_day ? index - current_day : 7 - (current_day - index)))
    }

    for (let spec_hours of (special_hours || [])) {
      let spec_start = spec_hours.startDate ?
          new Date(spec_hours.startDate.year, spec_hours.startDate.month - 1, spec_hours.startDate.day) : null
      let spec_end = spec_hours.endDate ?
          new Date(spec_hours.endDate.year, spec_hours.endDate.month - 1, spec_hours.endDate.day,
              23, 59, 59) : null
      if (spec_start === null || spec_start <= dow_date) {
        if (spec_end === null || spec_end >= dow_date) {
          if (spec_hours.isClosed) {
            return {start: null, end: null, special: true}
          }
          return {start: spec_hours.openTime, end: spec_hours.closeTime, special: true}
        }
      }
    }
    return day
  })
}


const get_session = function (key, parse) {
  try {
    let r = sessionStorage.getItem(key)
    return parse && r ? JSON.parse(r) : r
  } catch (e) {
    console.error('Could not read session storage', key, e)
  }
  return null
}

const get_local = function (key) {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    console.error('Could not read local storage', key, e)
  }
  return null
}

const set_session = function (key, value) {
  try {
    return sessionStorage.setItem(key, value)
  } catch (e) {
    console.error('Could not set session storage', key, e)
  }
  return null
}

const set_local = function (key, value) {
  try {
    return localStorage.setItem(key, value)
  } catch (e) {
    console.error('Could not set local storage', key, e)
  }
  return null
}

const delete_session = function (key) {
  try {
    return sessionStorage.removeItem(key)
  } catch (e) {
    console.error('Could not delete session storage', key, e)
  }
  return null
}

const delete_local = function (key) {
  try {
    return localStorage.removeItem(key)
  } catch (e) {
    console.error('Could not delete local storage', key, e)
  }
  return null
}

const title_case = function(string){
  let out = []
  for (let word of string.split(/\s/g)){
    out.push(word.substring(0, 1).toUpperCase() + word.substring(1))
  }
  return out.join(' ')
}

const format_date = function (date_obj, locale) {
  return title_case(date_obj.toLocaleString(locale, {month:'short', day:'numeric'}).replace('.', ''))
}

const format_date_year = function (date_obj, locale) {
  return title_case(date_obj.toLocaleString(locale, {month:'short', day:'numeric', year: 'numeric'}).replace('.', ''))
}

export {
  merge_normal_and_special_hours,
  unescapeHTML,
  handleize,
  objectsAreEqual,
  timeConvert,
  weekdays,
  weekdays_short,
  format_date,
  format_date_year,
  get_session,
  get_local,
  set_session,
  set_local,
  delete_session,
  delete_local
}